// LIBRERIE/IMPORTS
import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from 'react-router-dom';

const BannerVendi: React.FC = () => {
    const { t } = useTranslation();

    const buttonText = t('homePage.sellBanner.cta');

    return (
        <section id="bannerValuta" className="space-ptb">
            <div className="container text-center">
                <h2 className="mb-3" dangerouslySetInnerHTML={{ __html: t('homePage.sellBanner.title') as string }}></h2>
                <div className="row justify-content-around align-items-center mb-3">
                    <p dangerouslySetInnerHTML={{ __html: t('homePage.sellBanner.para1') as string }}></p>
                    <p dangerouslySetInnerHTML={{ __html: t('homePage.sellBanner.para2') as string }}></p>
                </div>
                <Link className="btn btn-primary text-uppercase" to="/vendi-casa" title={buttonText}>
                    {buttonText}
                </Link>
            </div>
        </section>
    );
};

export default BannerVendi;